export class ListCarModelService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(params) {
    return await this.httpClient.get('/veiculos/buscaVeiculos', { params })
  }
}
